"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  optValue: 'asian',
  optLabel: 'race.asian'
}, {
  optValue: 'black',
  optLabel: 'race.black'
}, {
  optValue: 'native',
  optLabel: 'race.native'
}, {
  optValue: 'hispanic',
  optLabel: 'race.hispanic'
}, {
  optValue: 'white',
  optLabel: 'race.white'
}, {
  optValue: 'multi_racial',
  optLabel: 'race.multi_racial'
}, {
  optValue: 'not_listed',
  optLabel: 'race.not_listed'
}, {
  optValue: 'prefer_not_specify',
  optLabel: 'race.prefer_not_specify'
}];
exports.default = _default;